import { Link } from 'react-router-dom';

const SERVICE_AREAS = [
  'Orlando', 'Winter Park', 'Altamonte Springs', 'Casselberry',
  'Lake Mary', 'Sanford', 'Oviedo', 'Apopka', 'Kissimmee',
  'Ocoee', 'Winter Garden', 'Longwood',
];

const EXPLORE_LINKS = [
  { label: 'SERVICES', href: '/services' },
  { label: 'COMMERCIAL', href: '/commercial' },
  { label: 'MEDICAL', href: '/medical' },
  { label: 'PRICING', href: '/pricing' },
  { label: 'ABOUT', href: '/about' },
  { label: 'BLOG', href: '/blog' },
  { label: 'TESTIMONIALS', href: '/testimonials' },
  { label: 'CONTACT', href: '/contact' },
];

export function Footer() {
  return (
    <footer className="relative bg-charcoal-deep border-t border-electric/20 pt-20 pb-8 overflow-hidden">
      <div className="absolute -bottom-32 left-0 right-0 flex justify-center pointer-events-none">
        <div className="font-display font-bold text-[22vw] text-white/[0.03] leading-none">SOTSVC</div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 pb-14">
          <div className="md:col-span-1">
            <Link to="/" aria-label="Sonz of Thunder Services - Home" className="inline-flex items-center gap-3 group">
              <span className="logo-badge logo-badge--footer transition-transform group-hover:scale-105">
                <img src="/images/sotsvc-logo.png" alt="SOTSVC — Sonz of Thunder Services" />
              </span>
              <div className="leading-none">
                <div className="font-display font-bold text-white text-lg tracking-wider">SONZ OF THUNDER</div>
                <div className="text-electric text-[10px] tracking-[0.35em] mt-1">SERVICES</div>
              </div>
            </Link>
            <p className="text-white/60 max-w-sm mt-6 leading-relaxed text-sm">
              Premium cleaning for Central Florida. Owner-led crews. Zero compromise. Licensed, insured, and loud about the details.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 bg-charcoal-mid/50 border border-thunder/40 px-4 py-2">
              <span className="text-thunder text-lg">&#9889;</span>
              <span className="font-display text-thunder tracking-[0.2em] text-[10px]">YOU'RE CLEAN OR YOU'RE DIRTY</span>
            </div>
          </div>

          <div>
            <div className="font-display text-electric tracking-[0.3em] text-xs mb-5">// EXPLORE</div>
            <ul className="space-y-3 font-display tracking-wider text-white/70">
              {EXPLORE_LINKS.map(({ label, href }) => (
                <li key={href}>
                  <Link to={href} className="hover:text-thunder text-sm transition">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-display text-electric tracking-[0.3em] text-xs mb-5">// SERVICE AREAS</div>
            <ul className="space-y-2 text-white/70 font-body text-sm">
              {SERVICE_AREAS.map((area) => (
                <li key={area}>
                  <Link
                    to={`/cleaning-services/${area.toLowerCase().replace(/\s+/g, '-')}-fl`}
                    className="hover:text-thunder transition"
                  >
                    {area}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-display text-electric tracking-[0.3em] text-xs mb-5">// CONTACT</div>
            <ul className="space-y-3 text-white/70 font-body text-sm">
              <li>
                <a href="tel:4074616039" className="hover:text-thunder transition">(407) 461-6039</a>
              </li>
              <li>
                <a href="mailto:dalvarez@sotsvc.com" className="hover:text-thunder transition">dalvarez@sotsvc.com</a>
              </li>
              <li>Altamonte Springs, FL</li>
              <li>Sun–Fri · 7am–10pm</li>
              {/* Google Review link verified April 15 2026 — temporarily disabled
              <li>
                <a
                  href="https://g.page/r/CT-n2SDV_OOKEBI/review"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-electric transition text-electric/80 font-display tracking-wider text-xs"
                >
                  ★ LEAVE A GOOGLE REVIEW
                </a>
              </li>
              */}
            </ul>

            <div className="mt-8 flex gap-4">
              <a
                href="https://www.facebook.com/share/19U4RrwrF6/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 border border-electric/40 flex items-center justify-center text-electric hover:bg-electric hover:text-charcoal-deep transition"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a
                href="https://www.instagram.com/sonz_of_thunder_72?igsh=d3FsY2xnNTZ5NGE5&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 border border-electric/40 flex items-center justify-center text-electric hover:bg-electric hover:text-charcoal-deep transition"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
            </div>

            <div className="mt-6 text-xs text-white/40">In association with Coverall</div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-white/40 text-xs font-display tracking-[0.2em]">
          <div>&copy; {new Date().getFullYear()} &middot; SONZ OF THUNDER SERVICES &middot; SOTSVC.COM</div>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-thunder transition">PRIVACY</Link>
            <Link to="/terms" className="hover:text-thunder transition">TERMS</Link>
            <Link to="/service-areas" className="hover:text-thunder transition">AREAS</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
